import { Status } from '@/families/models/status';
import { BaseStatuses } from '@/constants/status-constants';

/**
 * returns custom status names to allow for dynamic content on the families table header
 *
 * @param statuses
 * @param base
 */
export function getStatusName(statuses: Array<Status>, base: BaseStatuses): string {
    const status = statuses.find(status => status.id === base);
    if (status) {
        let name = status.name;
        if (status.name.includes('(' && ')')) {
            name = status.name.replace(/ *\((.+)\) */, '');
        }
        if (status.id === BaseStatuses.WAIT_LIST) {
            const lowerCaseName = name.toLowerCase();
            if (lowerCaseName === 'wait list' || lowerCaseName === 'waitlist') {
                return 'Waitlisted Children';
            }
        }
        const appendedText = status.child_only ? ' Children' : '';
        return name + appendedText;
    } else {
        return '';
    }
}

/**
 * Filters statuses to return only those between WAIT_LIST and LOST_OPP (exclusive)
 * Returns statuses sorted by order, starting from WAIT_LIST up to but not including LOST_OPP
 *
 * @param statuses Array of all available statuses
 * @returns Filtered array of statuses
 */
export function getStatusesBetweenWaitListAndLostOpp(statuses: Array<Status>): Array<Status> {
    if (!statuses) {
        return [];
    }

    const sortedStatuses = statuses
        .sort((a, b) => a.order - b.order);

    let includeStatus = false;
    const filteredStatuses: Array<Status> = [];
    for (const status of sortedStatuses) {
        if (status.id === BaseStatuses.WAIT_LIST) {
            includeStatus = true;
            continue;
        }
        if (!includeStatus) {
            continue;
        }
        if (status.id === BaseStatuses.LOST_OPP) {
            break;
        }

        filteredStatuses.push(status);
    }

    return filteredStatuses;
}
